import type { MenuCategory, NavCategory } from './types'

/**
 * El backend expone "Musicales" como categoría de primer nivel (`nicename:
 * 'musicales'`), pero no existe una PLP `/musicales/{location}` — es una
 * subcategoría de Teatro. Se fuerza su href a la subcategoría real.
 */
const MUSICALES_HREF = (location: string): string => `/teatro/${location}/musicales`

/** Categorías del backend que no se muestran en el menú. */
const HIDDEN_CATEGORIES = new Set(['eventos-online'])

/**
 * Mapea el `menu` del backend al modelo de navegación del drawer, incluyendo la
 * localización en el href:
 *   - categoría    → `/{nicename}/{location}`
 *   - subcategoría → `/{genre}/{location}/{style}` (p. ej. `/conciertos/todos/pop`)
 */
export function toNavCategories(menu: MenuCategory[], location: string): NavCategory[] {
  return menu.filter((category) => !HIDDEN_CATEGORIES.has(category.nicename)).map((category) => ({
    id: category.nicename,
    label: category.name,
    href: category.nicename === 'musicales' ? MUSICALES_HREF(location) : `/${category.nicename}/${location}`,
    subcategories:
      category.items?.map((item) => ({
        label: item.text,
        href: `/${item.genre}/${location}/${item.style}`,
      })) ?? undefined,
  }))
}
